import { message } from 'antd'
import { getProps } from '../props';
import { createClientSite } from '../../../HttpRequests/clientSites';

export default (values) => async () => {

  const data = {
    client_id: getProps().clientId,
    ...values
  }

  const response = await createClientSite({ data });

  const clientSite = response.data.data;

  message.success('Site Created');

  return clientSite;

}